/**
 * Counters — numbers marked [data-fact] count up the first time they come
 * into view. "3,358", "~670", "11k+": prefix, digits (with separators) and
 * suffix are kept; a leading zero keeps its width ("07").
 *
 * @module motion/counters
 */

import { REDUCED_MOTION } from '../config.js';
import { $$ } from '../lib/dom.js';
import { gsap } from '../lib/gsap.js';

const FACT = /^(\D*)([\d,]+)(.*)$/;

export function animateCounters() {
    if (REDUCED_MOTION) {
        return;
    }

    $$('[data-fact]').forEach((element) => {
        const parts = FACT.exec(element.dataset.fact);

        if (!parts) {
            return;
        }

        const [, prefix, digits, suffix] = parts;
        const target = Number.parseFloat(digits.replaceAll(',', ''));
        const grouped = digits.includes(',');
        const counter = { value: 0 };

        gsap.to(counter, {
            value: target,
            duration: 1.7,
            ease: 'power2.out',
            scrollTrigger: { trigger: element, start: 'top 94%', once: true },
            onUpdate: () => {
                let text = String(Math.round(counter.value));

                if (grouped) {
                    text = text.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                }

                if (digits.startsWith('0')) {
                    text = text.padStart(digits.length, '0');
                }

                element.textContent = prefix + text + suffix;
            },
        });
    });
}
